import React from 'react'
import { Modal, Frame } from '@react95/core'
import { Heading, Text, Link as ExternalLink } from '@pancakeswap/uikit'
import { Progman21 } from '@react95/icons'
import { useTranslation } from 'contexts/Localization'

const PrivacyPolicyModal = ({ close, modalStyle, frameStyle }) => {
  const { t } = useTranslation()

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<Progman21 />}
      title="Privacy Policy"
      closeModal={close}
      width="90vw"
      height="90vh"
      style={modalStyle}
      buttons={[{ value: 'Ok', onClick: close }]}
    >
      <Frame style={frameStyle}>
        <Heading scale="xl" mb="16px" mt="16px">
          {t(`Last updated: November 01, 2021`)}
        </Heading>

        <Text fontSize="18px" mb="24px">
          {t(
            `We at Windoge95 are committed to protecting any data that we collect that concerns you, the user. By using our services, you agree to the use of the data that we collect in accordance with this Privacy Policy.`,
          )}
        </Text>

        <Text fontSize="18px" fontWeight="bold" mb="24px">
          {t(`We are committed to protecting your privacy.`)}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `We collect the minimum amount of information about you that is commensurate with providing you with a satisfactory service. This Policy indicates the type of processes that may result in data being collected about you. The purpose of this Privacy Policy to enable you to understand which personal identifying information (“PI”, “Personal Information”) of yours is collected, how and when we might use your information, who has access to this information, and how you can correct any inaccuracies in the information. To better protect your privacy, we provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used. To make this notice easy to find, we make it available on our website.`,
          )}
        </Text>
        <Text fontSize="18px" fontWeight="bold" mb="24px">
          {t(`Information Collected`)}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `We may collect any or all of the information that via both automated means such as communications profiles and cookies. Personal Information you give us depends on the type of service, support, or sale inquiry, and may include your name, address, telephone number, fax number and email address, dates of service provided, types of service provided, payment history, manner of payment, amount of payments, date of payments, domain name or other payment information. All sensitive information is collected on a secure server and data is transferred . When transferring personal information a security icon will appear in your browser.`,
          )}
        </Text>
        <Text fontSize="18px" fontWeight="bold" mb="24px">
          {t(`Information Use`)}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `This information is used for billing and to provide service and support to our customers. We may also study this information to determine our customers needs and provide support for our customers. All reasonable precautions are taken to prevent unauthorised access to this information. This safeguard may require you to provide additional forms of identity should you wish to obtain information about your account details. RunePay may email its monthly newsletter to the primary contact e-mail on file, but customers are able to opt out of this newsletter at any time.`,
          )}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `We use IP addresses to analyze trends, administer our site and servers, track access, and gather broad demographic information for aggregate use. IP addresses are not linked to personally identifiable information. It is possible that personal information about a customer may be included in the log files due to the normal functions of IP addresses and SaaS applications.`,
          )}
        </Text>
        <Text fontSize="18px" fontWeight="bold" mb="24px">
          {t(`Cookies`)}
        </Text>
        <Text fontSize="18px" mb="24px">
          {t(
            `Your Internet browser has the in-built facility for storing small text files – “cookies” – that hold information which allows a website to recognize your account. We use cookies to save your preferences and login information, and provide personalized functionality. You can reject cookies by changing your browser settings, but be aware that this will disable some of the functionality on the WINDOGE95 website. More information about cookies can be found at:`,
          )}
        </Text>
        <ExternalLink external href="https://en.wikipedia.org/wiki/HTTP_cookie." target="_blank">
          https://en.wikipedia.org/wiki/HTTP_cookie.
        </ExternalLink>
      </Frame>
    </Modal>
  )
}

export default PrivacyPolicyModal
